const THREE = require('three');

/* init threejs */
export default class Experiment {
	constructor() {
		this.vw = window.innerWidth;
		this.vh = window.innerHeight;
		/* Init renderer */
		this.renderer = new THREE.WebGLRenderer({ antialias: true });
		this.renderer.setSize(this.vw, this.vh);
		document.body.appendChild(this.renderer.domElement);
		
		/* Init scene */
        this.scene = new THREE.Scene();
        this.scene.name = 'Scene';
		window.scene = this.scene;
		
		/* add GUI */
		// this.gui = new dat.GUI();

        window.addEventListener('resize', this.windowResize.bind(this));
    }


    windowResize() {
        this.vw = window.innerWidth;
        this.vh = window.innerHeight;
        this.camera.aspect = this.vw / this.vh;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(this.vw, this.vh);       
    }

    getPerspectiveCamera() {
        /* Init camera */
		const vw = this.vw;
		const vh = this.vh;        
        this.camera = new THREE.PerspectiveCamera(45, vw/vh, 0.1, 1000);
        this.camera.position.set(0, 0, 150);
    }

    getOrtographicCamera() {
		const vw = this.vw;
		const vh = this.vh;            
        this.camera = new THREE.OrthographicCamera( vw / - 2, vw / 2, vh / 2, vh / - 2, 1, 1000 );
        this.camera.position.set(0, 0, 100);
    }

    isInView(obj) {
        const frustum = new THREE.Frustum();
        frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse));  
        
        // Your 3d point to check
        var pos = new THREE.Vector3(obj.position.x, obj.position.y, obj.position.z);
        return frustum.containsPoint(pos);       
    }
    
    ambientLight() {
        const light = new THREE.AmbientLight( 0xFFFFFF, 0.5 );
        light.name = 'Ambient light';
        this.scene.add(light);
    }


    directionalLight() {
        const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.6 );
        directionalLight.name = "Directional light";
        this.scene.add( directionalLight );

        const target = new THREE.Object3D();
        target.name = "Light target";
        this.scene.add(target);
        target.position.set(0, -50, -50);

        directionalLight.target = target;
    }

	
	renderLoop(callback) {
		callback();
        requestAnimationFrame(this.render.bind(this, callback));
        // this.renderLoop.bind(this, callback);
	}
	
	render() {
        window.requestAnimationFrame(function() {this.renderer.render(this.scene, this.camera) }.bind(this));
	}
}




// WEBPACK FOOTER //
// ./roll_of_honor/javascript/Experiment.js